import React, { Fragment, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountExpenseCategoryAsync, updateAccountExpenseCategoryAsync, resetSelectedRecordObjectInState } from "./expenseCategorySlice";
import { ExpenseCategoryInitialsForAdd, ExpenseCategoryInitialsForUpdate } from "./interfaces/expenseCategoryClass";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { determineCommaSeprater, dropDownSelectionStyles, FormatInvoiceDecimalNumber, getValueFromResource, parseLocalizedNumber } from '../../../common/timeLiveFunction';

export const ExpenseCategoryForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { t } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const { maxMenuHeight, cultureInfoName, decimalPlaces } = useAppSelector(state => state.globalState);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(ExpenseCategoryInitialsForAdd);
    const { selectedRecord, ExpenseCategoryList, isLoading } = useAppSelector((state) => state.expenseCategory);
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [statusTypeArray, SetstatusTypeArray] = useState<any | ''>([]);
    const dispatch = useAppDispatch();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const formikRef = useRef<any>(null);
    const getAccountExpenseTypeAsync = async () => {
        const response = await fetchAPI("api/v2/ExpenseTypes/ExpenseTypesForDropDown", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountExpenseTypeId;
            item.label = item.ExpenseType;
            delete item.AccountExpenseTypeId;
            delete item.ExpenseType;
        });
        const finalData = [{ label: 'None', value: 0 }, ...json.Data];
        SetstatusTypeArray(finalData);

    }

    useEffect(() => {
        getAccountExpenseTypeAsync();
    }, [])

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(ExpenseCategoryInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.DefaultExpenseRate = (stateItem.DefaultExpenseRate === null || stateItem.DefaultExpenseRate === undefined) ? 0 : stateItem.DefaultExpenseRate;
            stateItem.IsBillable = stateItem.IsBillable === 'Yes' ? true : false;
            stateItem.DisabledEditingOfRate = stateItem.DisabledEditingOfRate === 'Yes' ? true : false;
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            stateItem.DefaultExpenseRate = FormatInvoiceDecimalNumber(cultureInfoName.toString(),stateItem.DefaultExpenseRate, decimalPlaces);

            setCurrentFieldsData(stateItem);
            setSelectedOptionDropDown({ value: stateItem.AccountExpenseTypeId, label: stateItem.AccountExpenseName });
        }
        else {
            setSelectedOptionDropDown({ value: '', label: '' });
            setCurrentFieldsData(ExpenseCategoryInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }        
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        calculatedDisabledValue();

    }, [selectedRecord])

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const handleChange = (data: any) => {

        const { value, label } = data;
        setSelectedOptionDropDown({ value: value, label: label });
        setCurrentFieldsData({ ...currentFieldsData, 'AccountExpenseTypeId': value });
    };
    const handleSubmit = (values: any) => {

         const formattedValues = {
                                ...values,
                                DefaultExpenseRate: parseLocalizedNumber(values.DefaultExpenseRate)}
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountExpenseCategoryAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Expense Category Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                }).catch((rejectedValueOrSerializedError) => {
                })
        }
        else {

            dispatch(addAccountExpenseCategoryAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Expense Category Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                }).catch((rejectedValueOrSerializedError) => {
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    const calculatedDisabledValue = () => {
        if (ExpenseCategoryList.length > 0) {
            let index = 0;
            ExpenseCategoryList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(ExpenseCategoryList.length - index);
        }
    }
    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={{
                    ...currentFieldsData,
                    AccountExpenseTypeId: selectedOptionDropDown?.value || "",
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}

                validationSchema={yup.object().shape({
                    AccountExpenseName: yup
                        .string()
                        .label('ExpenseName')
                        .trim()
                        .required
                        // (t('Expense Category Name is required'))
                        (getValueFromResource('Expense Category Name is required',dispatch, t))

                        .max(200, 
                            // 'Expense Category Name must not exceed 200 Characters'),
                            getValueFromResource('Expense Category Name must not exceed 200 Characters',dispatch, t)),
                    AccountExpenseTypeId: yup
                        .string()
                        .label('AccountExpenseTypeId')
                        .trim()
                        .notOneOf([ '0' ], getValueFromResource('Expense Type is required', dispatch, t))
                        .required
                        // (t('Expense Type is required')),
                        (getValueFromResource('Expense Type is required',dispatch, t)),
                    // DefaultExpenseRate: yup
                    //     .number()
                    //     .min(0,
                    //         //  t('Value must be greater than or equal to 0'))
                    //         getValueFromResource('Value must be greater than or equal to 0',dispatch, t))

                    //     .required
                    //     // (t('Default Expense Rate is required')),
                    //     (getValueFromResource('Default Expense Rate is required',dispatch, t))
                     DefaultExpenseRate: yup.string()
                                                        .test(
                                                            'culture-format-check',
                                                            () => {
                                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                                return isComma
                                                                    ? "Only numbers and comma (,) are allowed."
                                                                    : "Only numbers and dot (.) allowed";
                                                            },
                                        
                                                            (value) => {
                                                                if (!value) return true;
                                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                                if (isComma) {
                                                                    return /^\d+(,\d+)?$/.test(value);
                                                                } else {
                                                                    return /^\d+(\.\d+)?$/.test(value);
                                                                }
                                                            }
                                                        )
                                                        .test(
                                                            'greater-than-zero',
                                                            getValueFromResource('Default Expense Rate must be greater than or equal to 0', dispatch, t),
                                                            (value) => {
                                                                if (!value) return true;
                                        
                                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                                let normalizedValue = value;
                                                                if (isComma) {
                                                                    normalizedValue = value.replace(',', '.');
                                                                }
                                        
                                                                const numberValue = parseFloat(normalizedValue);
                                                                return !isNaN(numberValue) && numberValue >= 0;
                                                            }
                                                        ),


                })}>
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>

                        <div className='card-body card-pad'>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className='row'>
                                        <div className="col-md-6 mb-2">
                                            <label className="fs-7 fw-normal">
                                                {/* {t('Expense Category Name')} */}
                                                {getValueFromResource('Expense Category Name',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal mt-2"
                                                id='AccountExpenseName'
                                                name='AccountExpenseName'
                                                value={values.AccountExpenseName}
                                                onChange={handleChange('AccountExpenseName')}
                                                ref={defaultFocusRef}
                                            // onBlur={() => setFieldTouched('AccountExpenseName')}
                                            />
                                            <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                {touched.AccountExpenseName && errors.AccountExpenseName &&
                                                    <p className='errorMsg'>{errors.AccountExpenseName as string}</p>
                                                }
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-2">
                                            <label className="fs-7 fw-normal">
                                                {/* {t('Expense Type')} */}
                                                {getValueFromResource('Expense Type',dispatch, t)}
                                                </label>
                                            <Select
                                               value={values.AccountExpenseTypeId === "" || !statusTypeArray.some((option: any) => option.value === values.AccountExpenseTypeId)
                                                ? statusTypeArray[0]
                                                : statusTypeArray.find((option: any) => option.value === values.AccountExpenseTypeId)}
                                                // value={values.AccountExpenseTypeId != "" ? statusTypeArray.find((option: any) => option.value == values.AccountExpenseTypeId) : ""}
                                                className="basic-single mt-2"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                id="AccountExpenseTypeId"
                                                name="AccountExpenseTypeId"
                                                onBlur={() => setFieldTouched('AccountExpenseTypeId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "AccountExpenseTypeId",
                                                            value: selectedOption?.value
                                                        },
                                                    });
                                                }}
                                                options={statusTypeArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                            <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                {touched.AccountExpenseTypeId && errors.AccountExpenseTypeId &&
                                                    <p className='errorMsg'>{errors.AccountExpenseTypeId as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-2 mt-2">
                                            <label className="fs-7 fw-normal">
                                                {/* {t('Default Expense Rate')} */}
                                                {getValueFromResource('Default Expense Rate',dispatch, t)}
                                                </label>
                                            <input type="text"
                                                className="form-control fs-7 fw-normal mt-2"
                                                id='DefaultExpenseRate'
                                                name="DefaultExpenseRate"
                                                value={values.DefaultExpenseRate}
                                                onChange={handleChange('DefaultExpenseRate')}
                                                onBlur={() => setFieldTouched('DefaultExpenseRate')}
                                            />
                                            <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                {touched.DefaultExpenseRate && errors.DefaultExpenseRate &&
                                                    <p className='errorMsg'>{errors.DefaultExpenseRate as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-2 mt-2">
                                            <label className="fs-7 fw-normal">
                                                {/* {t('Disabled Editing Rate')} */}
                                                {getValueFromResource('Disabled Editing Rate',dispatch, t)}
                                                </label>
                                            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                <input className="form-check-input h-20px w-30px mt-2"
                                                    type="checkbox"
                                                    checked={values.DisabledEditingOfRate}
                                                    id="DisabledEditingOfRate"
                                                    name="DisabledEditingOfRate"
                                                    onChange={handleChange('DisabledEditingOfRate')}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-2 mt-2">
                                            <label className="fs-7 fw-normal">
                                                {/* {t('Billable')} */}
                                                {getValueFromResource('Billable',dispatch, t)}
                                                </label>
                                            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                <input className="form-check-input h-20px w-30px mt-2"
                                                    type="checkbox"
                                                    checked={values.IsBillable}
                                                    id="IsBillable"
                                                    name="IsBillable"
                                                    onChange={handleChange('IsBillable')}
                                                />
                                            </div>
                                        </div>
                                        {Object.keys(selectedRecord).length > 0 ? (
                                            disabledCount !== 1 ? <div className="mb-3" >
                                                <label className="fs-7 fw-normal mt-2">
                                                    {/* {t('Disabled')} */}
                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                        onChange={handleChange('IsDisabled')}
                                                    />
                                                </div>
                                            </div> : ExpenseCategoryList.find(x => x.AccountExpenseId === values.AccountExpenseId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                <label className="fs-7 fw-normal mt-2">
                                                    {/* {t('Disabled')} */}
                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                        onChange={handleChange('IsDisabled')}
                                                    />
                                                </div>
                                            </div>)
                                        ) : null}
                                    </div>
                                </>
                            }
                            {Object.keys(errors).length > 0 && (
                                <div className="mt-3 alert alert-danger">
                                    <strong>
                                        {/* {t('Error Summary')}: */}
                                        {getValueFromResource('Error Summary',dispatch, t)}:
                                        </strong>
                                    <ul>
                                        {Object.keys(errors).map((fieldName, index) => (
                                            <li key={index}>{errors[fieldName] as string}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className='card-footer pt-4 '>
                            <div className='d-flex flex-stack float-end'>
                                <div className='d-flex align-items-center me-2'>
                                    <button
                                        ref={closeButtonRef}
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                        id="kt_OffCanvas"
                                        onClick={handleCloseOnClickEvent}
                                    >
                                        {/* {t('Cancel')} */}
                                        {getValueFromResource('Cancel',dispatch, t)}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary"
                                        onClick={() => handleSubmit()} disabled={!isValid}
                                        data-kt-element='send'
                                    >
                                        {/* {t('Save')} */}
                                        {getValueFromResource('Save',dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </Fragment>
                )}
            </Formik>
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
